import { createFileRoute } from "@tanstack/react-router";
import Kundreferenser from "@/pages/Kundreferenser";
import { articlesByCategory } from "@/data/articles";
import { buildBreadcrumbSchema, getBreadcrumbTrail, buildCollectionSchema, buildPageSchema, buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/kundreferenser/")({
  head: () =>
    buildSeoHead(publicPageSeo.kundreferenser, [
      buildPageSchema(publicPageSeo.kundreferenser, "CollectionPage"),
      buildCollectionSchema(
        publicPageSeo.kundreferenser,
        articlesByCategory("referenser").map((article) => article.title),
      ),
      buildBreadcrumbSchema(getBreadcrumbTrail("/kundreferenser") ?? []),
    ]),
  component: Kundreferenser,
});
